import validator from 'validator'

export const util = {
  data: {
    dataType: false,
    condition: false,
    value: ''
  },
  checkIfMatch (trigger_val, condition, data_type) {

    let match = false
    let input = false
    let trigger = false

    if (condition == 'IsBlank') {
      match = this.isEmpty()
    } else if (this.condition == 'IsNotBlank') {
      match = this.isNotEmpty()
    } else {
      // Set values to the correct type
      if (data_type == 'date') {
        input = new Date(this.data.value)
        trigger = new Date(trigger_val)
      } else if (data_type == 'number' || data_type == 'boolean') {
        input = parseInt(this.data.value)
        trigger = parseInt(trigger_val)
      } else {
        input = this.data.value
        trigger = trigger_val
      }

      switch (condition) {
        case 'Equal':
          match = (input === trigger)
          break
        case 'NotEqual':
          match = (input !== trigger)
          break
        case 'LessThan':
          match = (input < trigger)
          break
        case 'LessThanOrEqual':
          match = (input <= trigger)
          break
        case 'GreaterThan':
          match = (input > trigger)
          break
        case 'GreaterThanOrEqual':
          match = (input >= trigger)
          break
      }
    }
    return match
  },
  validate (data_type) {
    if (this.isNotEmpty()) {
      switch (data_type) {
        case 'boolean':
          return this.isBool()
        case 'date':
          return this.isDate()
        case 'number':
          return this.isNumeric()
        case 'array':
          return this.isArray()
        case 'email':
          return this.isEmail()
        case 'email_confirm':
          if (this.data.value.primary == this.data.value.confirmed) {
            return validator.isEmail(this.data.value.primary)
          } else {
            return false
          }
        case 'zip':
          return this.isZip()
        default:
          return true
      }
    }
    return false
  },
  setValue (value) {
    let val = ''
    if (value !== undefined) {
      val = (value === Array || value === Object ? value : value.toString())
    }
    this.data.value = val
    return this
  },
  isEmpty () {
    return validator.isEmpty(this.data.value)
  },
  isNotEmpty () {
    return !validator.isEmpty(this.data.value)
  },
  isBool () {
    return validator.isBoolean(this.data.value)
  },
  isDate () {
    return validator.isDate(this.data.value)
  },
  isNumeric () {
    return validator.isInt(this.data.value)
  },
  isArray () {
    return (this.data.value === Array && this.data.value.length)
  },
  isEmail () {
    return validator.isEmail(this.data.value)
  },
  isZip () {
    return validator.isInt(this.data.value) && this.data.value.length == 5
  }
}
